import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { retryWhen, take } from 'rxjs/operators';
import { ConfigService } from 'src/app/services/config.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';

declare global {
  interface Window {
    BrScanSDKSelfie: any;
  }
}

@Component({
  selector: 'app-image-capture-serasa',
  templateUrl: './image-capture-serasa.component.html',
  styleUrls: ['./image-capture-serasa.component.scss']
})
export class ImageCaptureSerasaComponent implements AfterViewInit {

  @Output()
  imageCapture = new EventEmitter<{ image: string; appKey: string }>();

  @Output()
  captureError = new EventEmitter<string>();

  @Input() isSelf: Boolean = false;

  @Input() exibirTelaCaptura: Boolean = false;

  @Output()
  isLoading = new EventEmitter<Boolean>();

  constructor(
    private ngZone: NgZone
    , private el: ElementRef
    , private sessionStorageService: SessionStorageService
  
  ) {
  }

  loadScriptInIframe(iframeDocument: Document): Promise<void> {
    return new Promise((resolve, reject) => {
      if (iframeDocument.getElementById('brscan-sdk-selfie-script')) {
        resolve();
        return;
      }
      const script = iframeDocument.createElement('script');
      script.id = 'brscan-sdk-selfie-script';
      script.src = '/brscan-sdk-selfie.min.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Erro ao carregar o script no iframe'));
      iframeDocument.body.appendChild(script);
      this.isLoading.emit(false);
    });
  }

  ngAfterViewInit() {
    const iframe: HTMLIFrameElement = this.el.nativeElement.querySelector('#sdk-iframe');
    
    if (iframe) {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

      if (!iframeDocument) return;

        iframeDocument.open();
        iframeDocument.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
          </head>
          <body>
            <div id="selfie"></div>
          </body>
          </html>
        `);
        iframeDocument.close();
      
      this.ngZone.runOutsideAngular(() => {
        
      this.loadScriptInIframe(iframeDocument).then(() => {

        const selfieDiv = iframeDocument.getElementById('selfie');

        const key: string | undefined =
        this.sessionStorageService?.getEnvConfig()?.serasaSdkLegacyKey;

        if(!key) throw new Error('SDK Key não encontrada');

        if(!iframe.contentWindow) return;

        if(selfieDiv) {
          const sdkInstance = new iframe.contentWindow.BrScanSDKSelfie.Selfie(key);

          // sdkInstance.cameraTraseira = true;

          sdkInstance
          .iniciaSelfie(selfieDiv)
          .then((selfie: any) => {
          const selfieBase64 = selfie?.selfie.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');

          //ENVIA A IMAGEM
          this.ngZone.run(() => {
            this.imageCapture.emit({ image: selfieBase64, appKey: "" });
          });


          })
          .catch((err: any) => {
            this.ngZone.run(() => {
              console.log('Erro durante o processo de captura:', err);
              this.captureError.emit(err?.desc ?? "Oops. Houve algum problema durante a captura. Por favor tente novamente.");
            });
          });
        }


      }).catch((error) => {
        this.ngZone.run(() => {
          console.log('Erro ao carregar o script no iframe:', error);
          this.captureError.emit(error?.desc ?? "Oops. Houve algum problema. Por favor tente novamente.");
        });
      });

      });
    }

    function convertBase64ToBlob(b64ToConvert: string): Blob {
      const byteCharacters = atob(b64ToConvert);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'image/jpeg'});
  
      return blob;
    }

  }
}
